import img1 from '../../static/img/class_types_page/Floorplay_Low_Impact_Dance_Fitness.webp';
import img2 from '../../static/img/class_types_page/Floorplay_Low_Impact_Dance_Fitness_2.webp';
import quoteImg from '../../static/img/class_types_page/Floorplay_Low_Impact_Dance_Fitness_3.webp';

const Class = {
  code: 'floorplay',
  name: 'The Floorplay Class',
  sentence1: 'Nia FloorPlay uses space, time and gravity guided by the element of play to creatively condition the body. Learn to blend one move into the next to create a beautiful dance that massages and strengthens the whole body from fingers to toes.',
  sentence2: '',
  quoteSentence1: 'When I discovered Nia I discovered my joy, a new community of amazing friends, and a healthy body. Nia is one of the great loves of my life.',
  quoteAttr: 'Sarah W., Nia Student',
  img1,
  img2,
  quoteImg,
  img1Alt: 'A group of people in black clothing laying on the ground during one of Nia\'s low impact dance fitness classes',
  img2Alt: 'A person on the ground practicing somatic movements during a Nia low impact dance fitness class',
  quoteAlt: 'A quote that says "The art of creative play" in yellow script writing, illustrating how meaningful and fun Nia\'s low impact dance fitness classes are',
};

export default Class;
